import React, { useEffect, useState } from "react";
import epicBgimg from "./../../assets/images/epic-login-bg.png"
import epicLogo from "./../../assets/images/epic-product-logo.svg"
import microsoft from "./../../assets/images/microsoft.svg"
import { Link, useNavigate } from "react-router-dom";
import { ENDPOINTS } from "../../js/api/_config";
import axios from "axios";

import CustomCheckbox from "./custom-checkbox";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import Banner from "./banner";
import { useMsal } from "@azure/msal-react";
import { Toast } from "../common/toast/toast";
import { login } from '../../reducer/slices/user/userSlice';
import { useDispatch, useSelector } from "react-redux";

const Login = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { instance } = useMsal();

  const [showPass, setShowPass] = useState(false)
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [errors, setErrors] = useState("");
  const [toasts, setToasts] = useState([]);

  
  const [rememberMe, setRememberMe] = useState(false);
  const [apiLoader, setApiLoader] = useState(false)


  const validateFields = () => {
    const newErrors = {};

    if (!username.trim()) {
      newErrors.username = "Email is required";
    }
    else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(username)) {
      newErrors.username = "Invalid email format";
    }

    if (!password.trim()) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  useEffect(() => {
    setApiLoader(false)
    if (!username || !password) {
      const newErrors = {};
      newErrors.username = "";
      newErrors.password = "";
      setErrors(newErrors);
    }

  }, [username, password])

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    // const savedPassword = localStorage.getItem("rememberedPassword");
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }

  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
  
    if (!validateFields()) return;
  
    setApiLoader(true);
  
    try {
      const response = await axios.post(
        ENDPOINTS.AUTH.LOGIN,
        {
          email: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json-patch+json",
            Accept: "text/plain",
          },
        }
      );
  
      const data = response.data;
  
      dispatch(login({ user: null, token: data.token, refreshToken: data.refreshToken,rememberMe:rememberMe }));
      navigate("/dashboard");
    } catch (error) {
      console.error("Login failed:", error.response.data.message);
      addToast(error.response.data.message, "error");
      if (error.response && error.response.status === 401) {
        setError("Invalid username or password");
      } else {
        setError(error.response.data.message ||"Something went wrong. Please try again.");
      }
    } finally {
      setApiLoader(false);
    }
  };


  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  const handleMicrosoftSSO = async () => {
    try {

      const loginResponse = await instance.loginPopup();
      const accessToken = loginResponse.accessToken;
      // Send token to backend for validation
      const response = await axios.post(ENDPOINTS.MICROSOFTSSO.CODE_URL, accessToken, {
        headers: {
          "Content-Type": "application/json-patch+json",
          Accept: "text/plain",
        },
      });

      if (response.data.token) {
        dispatch(login({ user: null, token: response.data.token, refreshToken: response.data.refreshToken,rememberMe:rememberMe }));
        navigate("/dashboard");
      }else {
        addToast(error.response.data.message, "error");
      }
    } catch (error) {
      console.error("Error occurred during the API call:", error);
      if (error.status === 400) {
        addToast(error.response.data.message, "error");
      }
    }
  }

  return (
    <div className="flex h-screen overflow-hidden">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
      ))}
      {/* Left Side - Carousel */}
      <Banner />

      {/* Right Side - Login Form */}
      <div className="w-1/2 bg-white flex flex-col justify-center items-center px-8 relative">
        <div className="w-full max-w-[420px] ">
          {/* <img src={epicLogo} alt="Logo" className="mb-4" />
          <h1 className="text-[22px] font-[600] mb-2 font-mont">Welcome back!</h1>
          <p className="mb-6 font-mont">Login and continue your journey with us.</p> */}
          <div className="w-full">
            <img src={epicLogo} alt="Logo" className="mb-[60px] mx-auto w-[278px]" />
            <h2 className="text-[32px] font-[600] text-center font-mont mb-[40px]">Log in</h2>
            <button onClick={handleMicrosoftSSO}
              className="w-full bg-[#F9F9F9] text-[#737373] py-2 rounded hover:text-[#1B2A3D] hover:bg-[#F2F1F1] font-mont font-[600] text-[18px] flex mx-auto border border-[#C8D6E6] items-center justify-center my-[30px]"
              disabled={apiLoader}>
              <img src={microsoft} alt="Logo" className="mr-[13px]" /> <span className="">Login in with Microsoft</span>
            </button>
            <div className="flex mb-[15px] pt-3">
              <div className="h-[1px] bg-[#F0F1F3] w-2/4" >
              </div><div className="relative bottom-3 text-[16px] font-mont font-[600] w-[30px] text-center text-[#667783]">
                Or
              </div ><div className="h-[1px] bg-[#F0F1F3] w-2/4">
              </div>
            </div>
          </div>

          <form className="space-y-4" >
            <div>
              <label htmlFor="password" className="block text-sm text-gray-700 text-[16px] font-[600] mb-3">
                Email
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {errors.username && <span className="text-[#F95454] font-mont text-[14px] font-[500]">{errors.username}</span>}
            </div>
            <div>
              <label htmlFor="confirmPassword" className="block text-sm text-gray-700 text-[16px] font-[600] mb-3">
                Password
              </label>
              <div className="flex relative">
                <input
                  type={showPass ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <div className="absolute right-2 top-3">
                  {showPass ? <FaRegEyeSlash className="w-5 hover:text-[#245CEA]" onClick={() => { setShowPass(!showPass) }} /> :

                    <FaRegEye className="w-5 hover:text-[#245CEA]" onClick={() => { setShowPass(!showPass) }} />
                  }
                </div>
              </div>
              {errors.password && <span className="text-[#F95454] font-mont text-[14px] font-[500]">{errors.password}</span>}
            </div>

            <div className="flex items-center justify-between">
              <CustomCheckbox isChecked={rememberMe} setIsChecked={setRememberMe} />
              <Link to="/forgot-password" className="text-[#245CEA] text-[12px] font-[600]">
                Forgot Password?
              </Link>
            </div>
            <button
              onClick={(e) => handleLogin(e, { login })}
              className="w-full bg-[#245CEA] text-[#FFFFFF] py-2 rounded hover:bg-blue-600 font-mont font-[600] text-[18px] mt-[30px!important]"
              disabled={apiLoader}>{apiLoader ? <div className="flex justify-center"><div className="mini-spinner"></div></div> : "Login"}
            </button>
            {error && <p className="text-[#F95454] font-mont text-[14px] font-[500]">{error}</p>}
          </form>


        </div>
        <p className="text-center text-sm text-gray-500 absolute bottom-3">
          &copy; 2025 eClinRecruit. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Login;
